module.exports = __webpack_public_path__ + "img/recyclage_1.2cc55023.jpg";